import eventBus from '@/components/utils/slideout-panel/eventBus';
import BaseContextMenuMixin from '@/components/context-menus/BaseContextMenu';

const SelectableItemsContextMenu = {
  mixins: [
    BaseContextMenuMixin,
  ],
  data() {
    return {
      selectedItems: [],
    };
  },
  computed: {
    hasSelectedItems() {
      return this.selectedItemsCount > 0;
    },
    selectedItemsCount() {
      return this.selectedItems.length;
    },
  },
  methods: {
    itemsSelected(items) {
      this.selectedItems = items;
      if (this.hasSelectedItems) {
        this.showContextMenu();
      } else {
        this.hideContextMenu();
      }
    },
    clearSelected() {
      eventBus.$emit('clearSelected');
    },
  },
  created() {
    eventBus.$on('itemsSelected', this.itemsSelected);
  },
  destroyed() {
    eventBus.$off('itemsSelected', this.itemsSelected);
  },
};

export default SelectableItemsContextMenu;
